import { useMemo } from 'react';

import type { ProductLeftoverData } from '@app/pages/Warehouses/components/ProductLeftover/types';
import { getProductLeftover } from '@app/pages/Warehouses/components/ProductLeftover/utils/getProductLeftover';

export const useProductLeftover = (data: ProductLeftoverData) => {
  const { amount, physicalAmount, creditAmount, hasCreditResidual, unit } =
    data;

  return useMemo(
    () =>
      getProductLeftover({
        amount,
        physicalAmount,
        creditAmount,
        hasCreditResidual,
        unit,
      }),
    [amount, physicalAmount, creditAmount, hasCreditResidual, unit]
  );
};
